/**
 * Rechts-nach-links: lateinische Zahlen-/Maßausdrücke, die im arabischen Satz als Einheit
 * von links nach rechts stehen müssen (Server: server/lib/rtl.ts, Browser: client/rtl-bidi.ts).
 *
 * Folgt eine lateinische Ziffer auf arabische Buchstaben, macht der Bidi-Algorithmus daraus eine
 * "arabische Zahl" und ordnet "20 x 20 x 2 mm" in der falschen Reihenfolge ("x 20 x 2 mm 20").
 */

const ZAHL = String.raw`(?:Ø ?)?\d[\d.,/]*`;
const EINHEIT = String.raw`(?:mm|cm|m²|m³|kg/m²|kg|kN/m²|kN|W/\(m²K\)|°C|°|%|€)`;

const MUSTER = [
  // Maßkette: 200,5 × 84,5 × 127 cm, 20 x 20 x 2 mm, Ø 8,5 mm
  String.raw`(?:\b[A-Z][A-Za-z]{1,5}\b )?${ZAHL}(?: ?[x×] ?${ZAHL})+(?: ?${EINHEIT})?`,
  // Normbezeichnung mit Zahl: VSG 8/10 mm, RAL 7016, Torx 19 mm
  String.raw`\b[A-Z][A-Za-z]{1,5}\b ${ZAHL}(?: ?${EINHEIT})?`,
  // Zahl mit Einheit: 75 kg/m², 40 °C, 100 %, 30.000 €
  String.raw`${ZAHL}(?: | )?${EINHEIT}`,
  // E-Mail
  String.raw`[\w.+-]+@[\w-]+(?:\.[\w-]+)+`,
].join("|");

/** Neue Instanz je Aufruf: Muster mit /g tragen lastIndex-Zustand. */
export function ltrAbschnitte(): RegExp {
  return new RegExp(MUSTER, "g");
}
